/**
 * Typeracer Constants
 *
 * Centralized configuration values and magic numbers
 */
// Performance thresholds
export const PERFORMANCE = {
    MAX_KEYSTROKE_PROCESSING_TIME_MS: 5,
    STATS_UPDATE_INTERVAL_MS: 100,
    CARET_UPDATE_DELAY_MS: 100,
};
// Typing calculations
export const TYPING = {
    CHARACTERS_PER_WORD: 5,
    DEFAULT_WORD_COUNT: 50,
    DEFAULT_DURATION_SECONDS: 30,
    ESTIMATED_WPM_FOR_TIME_MODE: 40,
};
// Word counts for different modes
export const WORD_COUNTS = {
    WORDS_MODE: [10, 25, 50, 100],
    PARAGRAPHS_MODE: [1, 2, 3, 5],
};
// Time durations (in seconds)
export const DURATIONS = {
    TIME_MODE: [15, 30, 60, 120],
};
// Dictionary difficulty ranges
export const DIFFICULTY_RANGES = {
    WORDS: {
        easy: { min: 1, max: 4 },
        medium: { min: 5, max: 8 },
        hard: { min: 9, max: 12 },
        impossible: { min: 13, max: Infinity },
    },
    PARAGRAPHS: {
        easy: { min: 50, max: 200 },
        medium: { min: 201, max: 400 },
        hard: { min: 401, max: 600 },
        impossible: { min: 601, max: Infinity },
    },
};
// Consistency calculation
export const CONSISTENCY = {
    MAX_SPACING_MS: 1000,
    MIN_KEYSTROKES_FOR_CALCULATION: 2,
};
// History and storage
export const STORAGE = {
    MAX_HISTORY_SIZE: 50,
    DICTIONARY_CACHE_VERSION: '1.0.0',
};
// Mobile detection
export const MOBILE = {
    INPUT_MAX_LENGTH: 1000,
    INPUT_TRIM_LENGTH: 500,
    SCROLL_DELAY_MS: 300,
    MIN_TOUCH_TARGET_SIZE: 44,
};
// Animation timings
export const ANIMATION = {
    LETTER_CORRECT_DURATION_MS: 200,
    LETTER_INCORRECT_DURATION_MS: 200,
    WORD_PULSE_DURATION_MS: 2000,
    CARET_BLINK_DURATION_MS: 1060,
    FADE_IN_DURATION_MS: 600,
};
// Sound settings
export const SOUND = {
    VOLUME: 0.3,
    CORRECT_FREQUENCY: 800,
    INCORRECT_FREQUENCY: 400,
    COMPLETE_FREQUENCY: 1000,
    DURATION_MS: 50,
};
// Keyboard shortcuts
export const SHORTCUTS = {
    RESTART: ['Tab', 'Enter'],
    PAUSE: 'Escape',
};
// WPM tracking
export const WPM_TRACKING = {
    SAMPLE_INTERVAL_MS: 1000,
    MIN_SAMPLES: 2,
};
// Time-mode stream refill: prefetch before the typist hits the end
export const REFILL = {
    PREFETCH_REMAINING_WORDS: 8,
    BATCH_WORD_COUNT: 40,
};
